module.exports = __webpack_public_path__ + "img/Annotated_Beasts_Lair_Map.f06a19ad.png";